import React from 'react';
import { useIntl } from 'react-intl';

import { Checkbox, Row, Col } from 'antd';

import { Form } from 'common/components';

import { memberManagementFeatures } from 'static/Constants';
import Messages from 'i18n/messages/maintenance';

const MemberManagementEditForm = (props) => {
  const intl = useIntl();

  const { form, extraFields } = props;

  const renderFields = () => {
    return (
      <Row gutter={[16, 8]}>
        {memberManagementFeatures.map((field) => {
          return (
            <Col span={12} key={field}>
              <Form.Item
                name={field}
                valuePropName='checked'
                style={{ marginBottom: 0 }}
              >
                <Checkbox>{intl.formatMessage(Messages[field])}</Checkbox>
              </Form.Item>
            </Col>
          );
        })}
      </Row>
    );
  };

  return (
    <Form form={form} layout='horizontal'>
      {extraFields ? extraFields : null}
      {renderFields()}
    </Form>
  );
};

export default MemberManagementEditForm;
